export class ListData {
  canAdd!: boolean;
  pageIndex!: number;
  totalCount!: number;
  pageSize!: number;
  pageData!: {
    canDelete: boolean
    canEdit: boolean
    canEditStatus: boolean
    isActive: boolean
    id: number
    title: string
    recurringYear: string
    start: string
    end: string
    branches: branch[]
  }[];
}
export class Record {
  id!: any;
  title_AR!: string;
  title_EN!: string;
  recurringYear!: boolean;
  severalDays!: boolean;
  startDate!: date;
  endDate!: date;
  branches!: branch[]
}

export class branch {
  id!: any;
  title!: string
}
export class date {
  day!: number;
  month!: number;
  year!: number;
  isHijri!: boolean;
  gregorianDate!: string;
  gregorian!: date;
}

export class ListFilter {
  pageSize!: number;
  pageNumber!: number;
}
